import { useFormContext } from '@american-autonomy/ag-ui';

import FormGrid from 'components/FormGrid';
import BatteryNameField from 'components/fields/BatteryNameField';
import BatterySerialNumberField from 'components/fields/BatterySerialNumberField';

import useTranslation from './hooks/useTranslation';

import { BATTERY_NAME_FIELD_NAME, SERIAL_NUMBER_FIELD_NAME, TEST_ID } from './constants';
import type { BatteryFormSchema, FieldPath, Props } from './types';

const BatteryFormFields = <T extends BatteryFormSchema>({
    children,
    namePrefix,
    testId = TEST_ID
}: Props<T>) => {
    const { control } = useFormContext<T>();
    const { BATTERY_NAME_FIELD_PLACEHOLDER, SERIAL_NUMBER_FIELD_PLACEHOLDER } = useTranslation();

    const fieldName = (name: keyof BatteryFormSchema) =>
        (namePrefix ? `${namePrefix}.${name}` : String(name)) as FieldPath<T>;

    return (
        <FormGrid testId={testId}>
            <BatteryNameField<T>
                control={control}
                isRequired={true}
                name={fieldName(BATTERY_NAME_FIELD_NAME)}
                placeholder={BATTERY_NAME_FIELD_PLACEHOLDER}
            />

            <BatterySerialNumberField<T>
                control={control}
                isRequired={true}
                name={fieldName(SERIAL_NUMBER_FIELD_NAME)}
                placeholder={SERIAL_NUMBER_FIELD_PLACEHOLDER}
            />

            {children}
        </FormGrid>
    );
};

export default BatteryFormFields;
